import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";

function parseDetails(stashId, controllerIdOpt, nominatorsOpt, rewardDestination, validatorPrefs, exposure, stakingLedgerOpt) {
  return {
    accountId: stashId,
    controllerId: controllerIdOpt && controllerIdOpt.unwrapOr(null),
    exposure: exposure,
    nominators: nominatorsOpt.isSome ? nominatorsOpt.unwrap().targets : [],
    rewardDestination: rewardDestination,
    stakingLedger: stakingLedgerOpt.unwrapOrDefault(),
    stashId: stashId,
    validatorPrefs: validatorPrefs
  };
}

function getLedgers(api, optIds, _ref) {
  var _ref$withLedger = _ref.withLedger,
      withLedger = _ref$withLedger === void 0 ? false : _ref$withLedger;
  var ids = optIds.filter(function (opt) {
    return withLedger && !!opt && opt.isSome;
  }).map(function (opt) {
    return opt.unwrap();
  });
  var emptyLed = api.registry.createType('Option<StakingLedger>');
  return (ids.length ? api.query.staking.ledger.multi(ids) : of([])).pipe(map(function (optLedgers) {
    var offset = -1;
    return optIds.map(function (opt) {
      return opt && opt.isSome ? optLedgers[++offset] || emptyLed : emptyLed;
    });
  }));
}

function getStashInfo(api, stashIds, activeEra, _ref2) {
  var withController = _ref2.withController,
      withDestination = _ref2.withDestination,
      withExposure = _ref2.withExposure,
      withLedger = _ref2.withLedger,
      withNominations = _ref2.withNominations,
      withPrefs = _ref2.withPrefs;
  var emptyNoms = api.registry.createType('Option<Nominations>');
  var emptyRewa = api.registry.createType('RewardDestination');
  var emptyExpo = api.registry.createType('Exposure');
  var emptyPrefs = api.registry.createType('ValidatorPrefs');
  return combineLatest([withController || withLedger ? api.query.staking.bonded.multi(stashIds) : of(stashIds.map(function () {
    return null;
  })), withNominations ? api.query.staking.nominators.multi(stashIds) : of(stashIds.map(function () {
    return emptyNoms;
  })), withDestination ? api.query.staking.payee.multi(stashIds) : of(stashIds.map(function () {
    return emptyRewa;
  })), withPrefs ? api.query.staking.validators.multi(stashIds) : of(stashIds.map(function () {
    return emptyPrefs;
  })), withExposure ? api.query.staking.erasStakers.multi(stashIds.map(function (stashId) {
    return [activeEra, stashId];
  })) : of(stashIds.map(function () {
    return emptyExpo;
  }))]);
}

function getBatch(api, activeEra, stashIds, flags) {
  return getStashInfo(api, stashIds, activeEra, flags).pipe(switchMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 5),
        controllerIdOpt = _ref4[0],
        nominatorsOpt = _ref4[1],
        rewardDestination = _ref4[2],
        validatorPrefs = _ref4[3],
        exposure = _ref4[4];

    return getLedgers(api, controllerIdOpt, flags).pipe(map(function (stakingLedgerOpts) {
      return stashIds.map(function (stashId, index) {
        return parseDetails(stashId, controllerIdOpt[index], nominatorsOpt[index], rewardDestination[index], validatorPrefs[index], exposure[index], stakingLedgerOpts[index]);
      });
    }));
  }));
} //

/**
 * @description From a stash, retrieve the controllerId and all relevant details
 */


export function query(instanceId, api) {
  return memo(instanceId, function (accountId, flags) {
    return api.derive.staking.queryMulti([accountId], flags).pipe(map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          first = _ref6[0];

      return first;
    }));
  });
}
export function queryMulti(instanceId, api) {
  return memo(instanceId, function (accountIds, flags) {
    return accountIds.length ? api.derive.session.indexes().pipe(switchMap(function (_ref7) {
      var activeEra = _ref7.activeEra;
      var stashIds = accountIds.map(function (accountId) {
        return api.registry.createType('AccountId', accountId);
      });
      return getBatch(api, activeEra, stashIds, flags);
    })) : of([]);
  });
}